import React from "react";
import styles from "./styles/SpecialSection.scss";

const SpecialAttributeCard = ({ attribute }) => (
  <div className={styles.specialCard}>
    <div className={styles.specialCardContent}>
      <div className={styles.iconContainer}>
        <span>{attribute.label}</span>
      </div>
      <span className={styles.detailWrapper}>
        <div title={attribute.value} className={styles.value}>
          {attribute.value}
        </div>
        {attribute.label ? null : (
          <div title={attribute.title} className={styles.title}>
            {attribute.title}
          </div>
        )}
      </span>
    </div>
  </div>
);

export default SpecialAttributeCard;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/SpecialAttributeCard.tsx